// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pen-quill"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15.5 2L17 7L22 8.5L12.5 18L6.5 17.5L6 11.5L15.5 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.49994 17.5L12.4999 18L21.9999 8.5L16.9999 7M6.49994 17.5L5.99994 11.5L15.4999 2L16.9999 7M6.49994 17.5L3 21.0001M6.49994 17.5L16.9999 7","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PenQuillIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-quill',
    ref,
    icon: element,
  },
));

PenQuillIcon.displayName = 'PenQuillIcon';

export default PenQuillIcon;
